import * as React from 'react';

import { cn } from '../../../lib/utils';

import { formatE164UsDisplay } from './format-e164-us';

export interface PhoneLinkProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'children' | 'type'
> {
  /** E.164 value from the backend, e.g. +15551234567 */
  e164: string;
  /** Override visible label; defaults to {@link formatE164UsDisplay} */
  label?: React.ReactNode;
}

export const PhoneLink = React.forwardRef<HTMLButtonElement, PhoneLinkProps>(
  function PhoneLink(
    { e164, label, className, onClick, disabled, ...props },
    ref,
  ) {
    const trimmed = e164.trim();
    const isEmpty = trimmed.length === 0;
    const display = label ?? (!isEmpty ? formatE164UsDisplay(trimmed) : '-');
    const isDisabled = Boolean(disabled) || isEmpty;

    return (
      <button
        ref={ref}
        type="button"
        disabled={isDisabled}
        className={cn(
          'inline p-0 text-left font-inherit text-sm',
          'border-0 bg-transparent underline-offset-4',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          isDisabled
            ? 'cursor-default text-muted-foreground'
            : 'cursor-pointer text-primary hover:underline',
          className,
        )}
        onClick={onClick}
        {...props}
      >
        {display}
      </button>
    );
  },
);
